<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Delivery Unit Common Files",
    },
    components: {
        Layout,
        PageHeader,
        UploadPopover
    },
    data() {
        return {
            title: "Delivery Unit Common Files",
            items: [
                {
                    text: "Dashboard",
                    href: "/",
                },
                {
                    text: "Delivery Unit Common Files",
                    active: true,
                },
            ],
            uploadOptions: {
                type: `Common Files ${this.$store.state.data.cycle}`,
                placement: "lefttop",
                folder: "Planning",
            },
            documents: [],
            documentLoading: false,
            showPV: false,
            filterDocu: '',
            pageOptions: [12, 24, 48, 100],
            perPage: 12,
            currentPage: 1,
        };
    },
    computed: {
        filteredDocuments() {
            let data = this.documents;
            var total = this.currentPage * this.perPage;
            if (this.filterDocu.trim() != "" && this.filterDocu) {
                data = data.filter((document) => {
                    return document.description.toLowerCase().includes(this.filterDocu.toLowerCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
    },
    created(){
        this.changeCycle(this.$store.state.data.cycle);
    },
    methods: {
        changeCycle($event){
            this.uploadOptions.type = `Common Files ${$event}`;
            this.getDocumentList($event, this.$store.state.data.selectedDU.id);
        },
        uploadedDocument(response) {
            this.documents.push(response);
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        removeFile(id) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("filemanager/DeleteFile", id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            let index = this.documents.findIndex((item) => item.id == id);
                            this.documents.splice(index, 1);
                            this.showToast("Successfully removed!", "success");
                        })
                        .catch(() => {
                            this.showToast("Cannot be removed!", "error");
                        });
                }
            });
        },
        async getDocumentList(cycle, duId) {
            this.documentLoading = true;
            await this.$store
                .dispatch("filemanager/GetFiles", {
                    id: duId,
                    type: `Common Files ${cycle}`,
                })
                .then((res) => {
                    this.documents = res.data;
                })
                .catch(() => {
                    this.showToast(
                        "Something went wrong! - getting documents",
                        "error"
                    );
                });
            this.documentLoading = false;
        },
    }
}
</script>
<template>
    <Layout @changeCycle="changeCycle">
        <PageHeader :title="title" :items="items" />
        <div>
            <div class="row align-items-center">
                <div class="col-md-6 d-flex">
                    <div
                        id="tickets-table_filter"
                        class="dataTables_filter me-1"
                    >
                        <label
                            class="
                                d-inline-flex
                                align-items-center
                            "
                        >
                            <b-form-input
                                autocomplete="off"
                                v-model="filterDocu"
                                type="search"
                                placeholder="Search Document..."
                                class="form-control"
                            ></b-form-input>
                        </label>
                    </div>
                    <div
                        id="tickets-table_length"
                        class="dataTables_length"
                    >
                        <label
                            class="
                                d-inline-flex
                                align-items-center
                                mb-0
                            "
                        >
                            <b-form-select
                                class="form-select"
                                v-model="perPage"
                                size="sm"
                                :options="pageOptions"
                            ></b-form-select>
                        </label>
                    </div>
                </div>
                <div class="col-md-6 text-right">
                    <button class="btn btn-primary" :id="`common-files`" @click="showPV = true">
                        <i class="fas fa-plus"></i> Add More Files
                    </button>
                    <upload-popover
                        :option="
                            uploadOptions
                        "
                        :sourceId="
                            $store.state.data.selectedDU.id
                        "
                        @uploaded="uploadedDocument"
                        :showPV="showPV"
                        @closePopover="
                            showPV = false
                        "
                        :dzId="`dropzone-common-files`"
                        :pvId="`common-files`"
                    ></upload-popover>
                </div>
            </div>
        </div>
        <div
            class="
                d-flex
                justify-content-center
                align-items-center
            "
            v-if="
                documentLoading
            "
        >
            <div
                class="
                    preloader-component
                    me-2
                "
            >
                <div
                    class="
                        status
                    "
                >
                    <div
                        class="
                            spinner-chase
                            w-20px
                            h-20px
                        "
                    >
                        <div
                            class="
                                chase-dot
                            "
                        ></div>
                        <div
                            class="
                                chase-dot
                            "
                        ></div>
                        <div
                            class="
                                chase-dot
                            "
                        ></div>
                        <div
                            class="
                                chase-dot
                            "
                        ></div>
                        <div
                            class="
                                chase-dot
                            "
                        ></div>
                        <div
                            class="
                                chase-dot
                            "
                        ></div>
                    </div>
                </div>
            </div>
            <strong
                >Loading...</strong
            >
        </div>
        <div v-if="!documentLoading && documents.length > 0" class="row">
            <div
                class="
                    col-md-3
                    mb-2
                "
                v-for="(
                    y, index
                ) in filteredDocuments"
                :key="y.id"
            >
                <div
                    class="
                        position-relative
                        cursor-pointer
                        border
                        mt-2
                        br-5
                    "
                    :style="`z-index: ${
                        filteredDocuments
                            .length -
                        index
                    }`"
                >
                    <div
                        class="
                            border
                            p-3
                        "
                    >
                        <div>
                            <div
                                class="
                                    float-end
                                    ms-2
                                "
                            >
                                <b-dropdown
                                    id="dropdown-dropleft"
                                    right
                                    variant="link"
                                    toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                    menu-class="dropdown-menu-end"
                                    no-caret
                                >
                                    <template
                                        #button-content
                                    >
                                        <i
                                            class="
                                                mdi
                                                mdi-dots-horizontal
                                            "
                                        ></i>
                                    </template>
                                    <b-dropdown-item
                                        @click="
                                            openDocument(
                                                y
                                            )
                                        "
                                        ><i
                                            class="
                                                bx
                                                bx-link-external
                                                me-1
                                            "
                                        ></i
                                        >Open</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                        variant="danger"
                                        @click="removeFile(y.id)"
                                        ><i
                                            class="
                                                bx
                                                bx-trash
                                                me-1
                                            "
                                        ></i
                                        >Remove</b-dropdown-item
                                    >
                                </b-dropdown>
                            </div>
                            <div
                                class="
                                    avatar-xs
                                    me-3
                                    mb-2
                                "
                                @click="
                                    openDocument(
                                        y
                                    )
                                "
                            >
                                <div
                                    class="
                                        avatar-title
                                        bg-transparent
                                        rounded
                                    "
                                >
                                    <i
                                        v-if="
                                            y.fileType.includes(
                                                'image'
                                            )
                                        "
                                        class="
                                            mdi
                                            mdi-image
                                            font-size-24
                                            text-purple
                                        "
                                    ></i>
                                    <i
                                        v-if="
                                            y.fileType.includes(
                                                'application'
                                            )
                                        "
                                        class="
                                            mdi
                                            mdi-file-pdf-outline
                                            font-size-24
                                            text-danger
                                        "
                                    ></i>
                                </div>
                            </div>
                            <div
                                class="
                                    d-flex
                                "
                                @click="
                                    openDocument(
                                        y
                                    )
                                "
                            >
                                <div
                                    class="
                                        overflow-hidden
                                        me-auto
                                    "
                                >
                                    <h5
                                        class="
                                            font-size-14
                                            text-truncate
                                            mb-1
                                        "
                                    >
                                        {{
                                            y.description
                                        }}
                                    </h5>
                                    <p
                                        class="
                                            text-muted
                                            mb-0
                                        "
                                    >
                                        {{
                                            formatDateWithTime(
                                                new Date(
                                                    y.dateTimeUploaded
                                                )
                                            )
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!documentLoading && documents.length == 0">
            <div class="mt-5 text-center">
                <i class="fas fa-info-circle"></i> No documents found
            </div>
        </div>
        <div v-if="!documentLoading && documents.length > 0 && filteredDocuments.length == 0">
            <div class="mt-5 text-center">
                <i class="fas fa-info-circle"></i> Search not found
            </div>
        </div>
    </Layout>
</template>